import { FleetVehicleStatusEnum } from "services/api/fleet/vehicles/types";
import { CardSelectOption } from "ui/components/CardSelect/types";

import VehicleStatusDamageFields from "./components/VehicleStatusDamageFields";
import VehicleStatusReservationFields from "./components/VehicleStatusReservationFields";
import VehicleStatusArrivalFields from "./components/VehicleStatusArrivalFields";
import VehicleStatusInternalFields from "./components/VehicleStatusInternalFields";
import VehicleStatusUnavailableFields from "./components/VehicleStatusUnavailableFields";
import { VehicleReservationSourceEnum, VehicleStatusFieldsProps } from "./types";

/** Rezervacija se veže na ponudu ili se unosi ručno — ponuda već nosi kupca i rok. */
export const VEHICLE_RESERVATION_SOURCE_OPTIONS: CardSelectOption[] = [
  {
    id: VehicleReservationSourceEnum.OFFER,
    icon: "/media/icons/document.svg",
    title: "Po ponudi",
    description: "Kupac i rok se preuzimaju iz odabrane ponude",
  },
  {
    id: VehicleReservationSourceEnum.MANUAL,
    icon: "/media/icons/users.svg",
    title: "Bez ponude",
    description: "Rezervacija na dogovor — kupac i rok se upisuju",
  },
];

/**
 * Koja komponenta crta polja kojeg statusa. Prati podjelu na backendu — svaki extender
 * ima svoju komponentu; Nedostupno i Dokumentacija dijele jednu jer ni tamo nemaju extender.
 *
 * Status kojeg ovdje nema, a ima ulaz u `FLEET_VEHICLE_STATUS_DETAIL_FIELDS`, prikazuje samo
 * lokaciju — tako je kod statusa Slobodno, koji vlastitih polja nema.
 *
 * "Nedostupno – Servis" ovdje nema unosa: taj status otvara čarobnjak servisnog naloga
 * (`VehicleServiceEditCard`), jer mu detalj nije nekoliko polja nego dokument.
 */
export const VEHICLE_STATUS_FIELDS_COMPONENTS: Partial<
  Record<FleetVehicleStatusEnum, React.FC<VehicleStatusFieldsProps>>
> = {
  [FleetVehicleStatusEnum.UNAVAILABLE_DAMAGE]: VehicleStatusDamageFields,
  [FleetVehicleStatusEnum.UNAVAILABLE_DOCUMENTATION]: VehicleStatusUnavailableFields,
  [FleetVehicleStatusEnum.UNAVAILABLE]: VehicleStatusUnavailableFields,
  [FleetVehicleStatusEnum.RESERVED]: VehicleStatusReservationFields,
  [FleetVehicleStatusEnum.ARRIVING]: VehicleStatusArrivalFields,
  [FleetVehicleStatusEnum.ACTIVE_INTERNAL]: VehicleStatusInternalFields,
};
